import { render, staticRenderFns } from "./DodatniSadrzajEdit.vue?vue&type=template&id=5ec35d6e&scoped=true&"
import script from "./DodatniSadrzajEdit.vue?vue&type=script&lang=js&"
export * from "./DodatniSadrzajEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec35d6e",
  null
  
)

export default component.exports